
import Enumerable from "linq";
import { ModelEditableMixin } from "../../../system";
import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { DesignatedDoctorInformation } from "../../../../domain/user";
import { StandardOption } from "../../../system/selectors/mixins";

@Component({
})
export default class DesignatedDoctorSelectableMixin extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      values: null,
      selectedDesignatedDoctor: null,
    };
  }
  values: DesignatedDoctorInformation[];
  selectedDesignatedDoctor: DesignatedDoctorInformation;

  created() {
    const repository = DomainRegistry.user.getDesignatedDoctorRepository();
    repository.getAllEntities()
      .then(e => this.values = e)
      .catch(e => {
        this.$error(
          "指定医番号マスタ取得失敗",
          "指定医番号マスタを取得できませんでした。",
          e,
        );
      });
  }

  get isLoaded(): boolean {
    return !!this.values;
  }

  get validDesignatedDoctorInformations(): DesignatedDoctorInformation[] {
    const today = this.getToday();
    return Enumerable.from(this.values)
      .where(v => v.startDate <= today && today <= v.endDate)
      .toArray();
  }
  
  get options(): StandardOption<DesignatedDoctorInformation>[] {
    return Enumerable.from(this.validDesignatedDoctorInformations)
      .distinct(v => v.typeCode)
      .select(v => new StandardOption<DesignatedDoctorInformation>(v.typeName, v))
      .toArray();
  }
  
  private getToday(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return year.toString() + month + day;
  }

  areDesignatedDoctorEqual(source: DesignatedDoctorInformation, destination: DesignatedDoctorInformation): boolean {
    return (!source && !destination)
      || (source && destination && (source.typeCode === destination.typeCode));
  }
}
